import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./../App.css";
import "./css/top.css";
import {
  Button,
  RoundButton,
  PriceSlider,
  ShareButton,
} from "./../features/index.js";
import finish from "./../assets/finish.png";
import { Link } from "react-router-dom";
import Modal from "react-modal";
import axios from "axios";


const Top = () => {
  const [priceRange, setPriceRange] = useState([5000, 10000]);
  const [isShared, setIsShared] = useState(false);
  const [url, setUrl] = useState();
  const [copy, setCopy] = useState(false);
  const [modal, setModal] = useState(false);

  // 値受け渡し用の変数
  const [sendPersonName, setSendPersonName] = useState("");
  const [userId, setUserId] = useState("");

  const createUser = async () => {
    console.log(process.env.API_URL);
    try {
      const response = await axios.post(
        "https://dots-to-code2024-back.onrender.com" + "/user",
        {
          name: sendPersonName,
          min_price: priceRange[0],
          max_price: priceRange[1],
        }
      );
      const parsed = JSON.parse(response.data);
      const newUrl = generateUrl(parsed.id);
      setUrl(newUrl);
      setUserId(parsed.id);
    } catch (error) {
      console.error("エラーが発生しました:", error);
    }
  };

  //result画面に表示する用
  const navigate = useNavigate();
  const sendName = () => {
    navigate(`/result?name=${sendPersonName}&id=${userId}`);
  };

  //共有欄表示させる関数
  const showShare = () => {
    const newUrl = generateUrl();
    setUrl(newUrl);
    setIsShared(true);
  };

  // URLを生成する関数
  const generateUrl = (userId) => {
    return (
      "https://dots-to-code-thoughtful.vercel.app" +
      "/category" +
      "?user_id=" +
      userId
    );
  };

  // クリップボードにコピーする関数
  const copyToClipboard = async () => {
    await global.navigator.clipboard.writeText(url);
  };

  // 共有画面のモーダル開く関数
  const openModal = () => {
    setModal(true);
  };

  const closeModal = () => {
    setModal(false);
  };

  const handlePriceChange = (newPriceRange) => {
    setPriceRange(newPriceRange);
  };

  return (
    <div className="top section">
      <div className="top__container">
        <div className="container__text">
          ギフトを送りたい人の <br />
          名前を教えてください
        </div>
        <div className="name__container">
          <input
            type="text"
            value={sendPersonName}
            onChange={(event) => setSendPersonName(event.target.value)}
            placeholder="xxx"
          />
        </div>
      </div>
      <div className="top__container">
        <div className="container__text">価格帯を選択してください</div>
        <PriceSlider handlePriceChange={handlePriceChange} />

        <RoundButton
          className="price__button"
          children={"決定"}
          onClick={() => {
            createUser();
            showShare();
          }}
        ></RoundButton>
      </div>
      {isShared ? (
        <>
          <div className="top__container">
            <div className="top__img">
              <img src={finish} alt="" />
            </div>
            <div className="container__text">URLが発行されました!</div>
            <div className="container__subtext">
              {sendPersonName}さんに共有しましょう
            </div>
            <div className="container__url">
              <input className="url" type="text" value={url} readOnly />
              <div
                className="copy__button"
                onClick={() => {
                  copyToClipboard();
                  setCopy(true);
                }}
              >
                <i
                  className={
                    copy
                      ? "uil uil-file-check top__button-icon"
                      : "uil uil-copy top__button-icon"
                  }
                ></i>
              </div>
            </div>
            <RoundButton
              children={"共有"}
              onClick={() => openModal()}
            ></RoundButton>

            <Modal className="modal__content" isOpen={modal}>
              <div
                className="uil uil-times modal__close"
                onClick={closeModal}
              ></div>
              <div className="modal__title">----- 共有 -----</div>
              <div className="modal__container container grid">
                <div className="modal__title">
                  <ShareButton></ShareButton>
                </div>
              </div>
            </Modal>
          </div>
          <Button
            className="link__text"
            children={"結果を見る"}
            onClick={sendName}
          >
            結果を見る
          </Button>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Top;
